import React, { useEffect, useState } from 'react';
import config from '@config';
import { BOTTOM_INDENTS, COLORS } from '@constants';
import { useStore } from '@hooks';
import { Icon, Input, Typography } from '@ui';
import { copyToClipboard } from '@utils';
import { Divider, Form } from 'antd';
import { FIELD_NAMES } from '../../../../../constants';
import { usePropertyIdModal, useServiceAccountEmailModal } from '../../hooks';
import { QuestionIcon } from '../QuestionIcon';

const PropertyIdSection = () => {
    const store = useStore();
    const form = Form.useFormInstance();
    const { ga4PropertyIdSectionVisible } = store.accountsStore;
    const [showCopied, setShowCopied] = useState(false);
    const { showServiceAccountEmailModal } = useServiceAccountEmailModal();
    const { showPropertyIdModal } = usePropertyIdModal();

    useEffect(() => {
        if (showCopied) {
            const timer = setTimeout(() => {
                setShowCopied(false);
            }, 1000);

            return () => {
                clearTimeout(timer);
            };
        }
    }, [showCopied]);

    const handleCopy = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        await copyToClipboard(config.ga4ServiceAccount);
        setShowCopied(true);
    };

    const handleServiceAccountEmailModal = (e) => {
        e.preventDefault();
        e.stopPropagation();
        showServiceAccountEmailModal();
    };

    const handlePropertyIdModal = (e) => {
        e.preventDefault();
        e.stopPropagation();
        showPropertyIdModal();
    };

    if (!ga4PropertyIdSectionVisible) return null;

    return (
        <React.Fragment>
            <Divider margin='24px 0' />
            <Typography.Text type='body2' color={COLORS.$gray60Black} style={BOTTOM_INDENTS.S}>
                Allow Klickly to cross-reference revenue data with GA4 for precise ROI reporting. This requires
                &apos;Viewer&apos; access for the service account email below.
            </Typography.Text>
            <Input
                label='Service Account Email'
                value={config.ga4ServiceAccount}
                disabled
                style={BOTTOM_INDENTS.S}
                prefix={
                    <Icon
                        onClick={handleCopy}
                        size='24px'
                        color={showCopied ? COLORS.$forestGreen : COLORS.$gray60Black}
                        style={{ cursor: 'pointer' }}
                        component={() => (showCopied ? <Icon.CheckIcon /> : <Icon.CloneIcon />)}
                    />
                }
                suffix={<Icon onClick={handleServiceAccountEmailModal} component={() => <QuestionIcon />} />}
            />
            <Form.Item
                name={FIELD_NAMES.GOOGLE_ANALYTICS_PROPERTY_ID}
                rules={[
                    {
                        pattern: /^\d+$/,
                        message: 'Property ID must be numeric'
                    }
                ]}
                onBlur={() =>
                    form.setFieldValue(
                        FIELD_NAMES.GOOGLE_ANALYTICS_PROPERTY_ID,
                        form.getFieldValue(FIELD_NAMES.GOOGLE_ANALYTICS_PROPERTY_ID)?.trim()
                    )
                }
            >
                <Input
                    label='GA4 Property ID'
                    suffix={<Icon onClick={handlePropertyIdModal} component={() => <QuestionIcon />} />}
                />
            </Form.Item>
        </React.Fragment>
    );
};

export default PropertyIdSection;
